export const OLX_AUTOS_PHONE_IN_LISTING = 'olxautos_phone_in_listing';
export const OLX_RENEW_MOBILE_NAME = 'olx_renew_mobile';
export const OLX_RENEW_MOBILE_CAT_ALL_L2 = 'olx_renew_mobile_cat_all_l2';

export const FeatureMapFlag = {
    interest: 'i_am_interested',
    requestCallback: 'call_requested',
    chat: 'chat_cta',
    call: 'call',
    offer: 'offer',
    storeTestDrive: 'store_test_drive',
    homeTestDrive: 'home_test_drive',
    reserve: 'is_reserved',
    ivr: 'ivr_number',
    transactionInbox: 'transaction_inbox',
    myZone: 'my_zone',
    storeVisit: 'store_visit'
};

export const StatusClass = {
    letgoActive: 'letgo_active',
    letgoRejected: 'letgo_rejected',
    letgoSold: 'letgo_sold',
    letgoPending: 'letgo_pending',
    letgoDisabled: 'letgo_disabled'
};
export const PLATFORM_MAP = {
    MEXICO: {
        CODE: 'MX',
        HOST: 'www.olxautos.com.mx'
    },
    INDONESIA: {
        CODE: 'id',
        HOST: 'www.olxautos.co.id'
    },
    LETGO: {
        CODE: 'letgo',
        HOST: 'www.letgo.com'
    },
    CHILE: {
        CODE: 'cl',
        HOST: 'www.olxautos.cl'
    },
    INDIA: {
        CODE: 'en',
        HOST: 'www.olx.in'
    },
    ARGENTINA: {
        CODE: 'ar',
        HOST: 'www.olxautos.com.ar'
    }
};

export const ENV_MAP = {
    DEVELOPMENT: 'development',
    STAGING: 'staging',
    PRODUCTION: 'production'
};

// Store PANAMERA Custom header keys here
export const PANAMERA_HEADERS = {
    HOST: 'x-panamera-host',
    ORIGIN: 'x-origin-panamera'
};

// Store cypress related const here
export const CYPRESS = {
    env: {
        PLATFORM: 'PLATFORM',
        TRANSLATION: 'TRANSLATION',
        EMAIL: 'EMAIL',
        PASSWORD: 'PASSWORD'
    }
};

// Stores Translations here
export const TRANSLATIONS_CODE = {
    TURKEY: 'tr-TR',
    MEXICO: 'es-MX',
    INDONESIA: 'id',
    CHILE: 'es-CL',
    ARGENTINA: 'es-AR',
    INDIA_ENG: 'en-IN',
    INDIA_HINDI: 'hi-IN',
    DEFAULT: 'en'
};

export const DEFAULT_LISTING_ROUTES = {
    olxid: '/mobil-bekas_c198',
    olxmx: '/autos_c84',
    olxtr: '/autos_c84',
    olxcl: '/autos_c84'
};

export const LEAD_FORM_CONFIG = 'LEAD_FORM_CONFIG';
export const LEAD_FORM_ACTION = 'onInterestedTap';
export const CALL_ME_ACTION = 'assitiveChatOnTabCallBack';
export const TRADE_IN_ACTION = 'onExchangeCarTap';
export const ON_NOTIFY_TAP = 'onNotifyMeTap';
export const LeadFormType = {
    ON_INTERESTED_TAP: 'onInterestedTap',
    ON_NOTIFY_TAP: 'onNotifyMeTap'
};

export const LEAD_FORM_ACTIONS = [
    CALL_ME_ACTION,
    LEAD_FORM_ACTION,
    ON_NOTIFY_TAP
];

export const DEFAULT_STORE_TIME = {
    startTime: '10:00',
    endTime: '17:00'
};

export const adpvMx = {
    containerBanner: 'div[id="onetrust-close-btn-container"]',
    closeBanner: '.banner-close-button',
    interestedAutId: '[data-aut-id="interested"]',
    getLeadForm: '../src/mocks/leadFormData.json',
    postLeadForm: '../src/mocks/leads.json',
    submitAutId: '[data-aut-id="submitButton"]',
    closeThankYouAutId: 'button[data-aut-id="closeThankyou"]'
};

export const l2qFlowJSON = {
    model: '../src/mocks/l2q/model.json',
    year: '../src/mocks/l2q/year.json',
    variant: '../src/mocks/l2q/variant.json',
    registeredState: '../src/mocks/l2q/registeredState.json',
    mileage: '../src/mocks/l2q/mileage.json',
    carDetailsRcSuccess: '../src/mocks/l2q/carDetailsRcSuccess.json',
    carDetailsRcError: '../src/mocks/l2q/carDetailsRcError.json',
    leadSuccess: '../src/mocks/l2q/leadSuccess.json',
    quotePrediction: '../src/mocks/l2q/quotePrediction.json',
    noQuotePrediction: '../src/mocks/l2q/noQuotePrediction.json'
};

export const EXPIRATION = 5000;
export const GRID = 'grid';

export const DATA_AUT_IDS = {
    ADDRESS: 'address',
    FOLLOWING_COMP: 'following_comp',
    FOLLOWERS: 'followers',
    FOLLOWING: 'following',
    VIEW_AND_EDIT_PROFILE: 'view_and_edit_profile',
    MEMBERS: 'members',
    MEMBER_SINCE: 'member-since',
    INFO_FILLED: 'infoFilled',
    EDIT: 'edit',
    USER_CARD: 'userCard',
    EDIT_PROFILE: 'editProfile',
    PROFILE: 'profile',
    ELLIPSES: 'ellipsis',
    TOOLTIP: 'tooltip',
    LOGGEDUSER: 'loggedUser',
    SELLER_NAME: 'seller-name',
    CONSENT: 'consent',
    CONSENT_LABEL: 'consentLabel',
    POSTING_TAP_POST: 'posting_tap_post',
    CARS_PLACEHOLDER: 'cars_Placeholder',
    FAQ_HEADING_WRAPPER: 'heading-wrapper',
    FAQ_HEADER_TITLE: 'header-title',
    CONTENT_WRAPPER: 'contentWrapper',
    CONTAINER: 'container',
    EXAMPLE_PROPOSITION: 'exampleProposition',
    NEW_VARIANT_HEADER: 'newVariantHeader',
    ASSET: 'asset',
    SEE_EXAMPLE: 'seeExample',
    EXAMPLE_MODAL: 'exampleModal',
    LEARN_MORE: 'learnMore',
    PACKAGE_BTN: 'packageBtn',
    ADD_INFO: 'addInfo',
    BACK_BUTTON: 'backButton',
    SOLD_OUTSIDE_OLX: 'soldOutsideOlx',
    EDIT_PREMIUM_INFO: 'edit_premium'
};

export const ROLES = {
    TOOLTIP: 'tooltip'
};

export const leadFormJSON = {
    leadsPhoneExists: '../src/mocks/leadForm/leadsPhoneExists.json',
    leadsThankYou: '../src/mocks/leadForm/leadsThankYou.json',
    localeAutoSubmit: '../src/mocks/leadForm/localeAutoSubmit.json',
    localeLogInEmail: '../src/mocks/leadForm/localeLogInEmail.json',
    localeNonLogIn: '../src/mocks/leadForm/localeNonLogIn.json'
};

export const q2bFlowJSON = {
    configuration: '../src/mocks/q2b/configuration.json',
    noCenters: '../src/mocks/q2b/noCenters.json',
    centers: '../src/mocks/q2b/centers.json',
    timeslots: '../src/mocks/q2b/timeslots.json',
    noTimeslots: '../src/mocks/q2b/noTimeslots.json',
    appointments: '../src/mocks/q2b/appointments.json',
    appointment: '../src/mocks/q2b/appointment.json',
    duplicateAppointment: '../src/mocks/q2b/duplicateAppointment.json',
    reschedule: '../src/mocks/q2b/reschedule.json',
    cancel: '../src/mocks/q2b/cancel.json',
    status: '../src/mocks/q2b/status.json'
};

export const PRODUCT = {
    classified: 'classified',
    olxautos: 'olxautos'
};

export const HEADING_TYPE = {
    footnote: 'footnote',
    caption: 'caption',
    subtitle: 'subtitle'
};

export const SOCIAL_ICON_TYPE = {
    profile: 'profile'
};
export const l2qLoginJSONs = {
    login: '../src/mocks/l2qLogin/login.json',
    userMe: '../src/mocks/l2qLogin/user.json',
    authenticate: '../src/mocks/l2qLogin/authentication.json',
    suspended: '../src/mocks/l2qLogin/suspended.json'
};

export const MMTY_FIELDS_MAPPING = [
    {
        name: 'make',
        option: 'Volvo',
        fixture: 'getMake'
    },
    {
        name: 'year',
        option: '2014',
        fixture: 'getYear'
    },
    {
        name: 'model',
        option: 'Others',
        fixture: 'getModel'
    },
    {
        name: 'variant',
        option: 'Others',
        fixture: 'getVariant'
    },
    {
        name: 'registeredState',
        option: 'Delhi',
        fixture: 'getRegisteredState'
    },
    {
        name: 'mileage',
        option: '10,001 - 20,000 KM',
        fixture: 'getMileage'
    }
];

export const RESERVE = {
    ADP_RESERVE_CTA: 'adp_reserve_cta',
    ADP_BANNER: 'adp_banner',
    ADP_GETSTARTED_CTA: 'adp_getstarted_cta'
};

export const CTAS_ACTION = {
    onInterestedTap: 'onInterestedTap',
    assitiveChatOnTabCallBack: 'assitiveChatOnTabCallBack',
    chatWindowOnTapMeeting: 'chatWindowOnTapMeeting',
    onNotifyMeTap: 'onNotifyMeTap',
    onExchangeCarTap: 'onExchangeCarTap'
};

export const VARIANTS = {
    VARIANT_A: 'a',
    VARIANT_B: 'b',
    VARIANT_C: 'c'
};

export const SELL_MORE_MYADS_VERSION = 'myAds';

export const SHOW_BUSINESS_PACKAGES_URL = '/payments/businesspackages/myads_banner';

export const LACQUESIS_FEATURE_FLAG = {
    CHOOSE_PACKAGE: {
        olxin: 'ROAD-76068',
        olxid: 'ROAD-76070',
        olxtr: 'ROAD-74307'
    }
};

export const FLOW_STEP = {
    SINGLE_PACKAGE_PAGE: 'single package page',
    SEE_EXAMPLE_LINK: 'see_example_link',
    SEE_EXAMPLE_CTA: 'see_example_cta',
    SINGLE_PACKAGE_PAGE_BANNER: 'single package page banner'
};

export const EVENT_NAME = {
    MONET_EXAMPLE: 'monet_example',
    MONET_BUSINESS_START: 'monet_business_start',
    MONET_LEARN_MORE: 'monet_learn_more',
    MONET_SELECTION: 'monet_selection'
};

export const SELECT_FROM = {
    BUSINESS_PACKAGE_APPLICATION: 'business_package_application'
};

export const AI_VIDEO_ADS_VARIANT = {
    AI_ON: 'AI-ON',
    AI_OFF: 'AI-OFF'
};

export const AI_VIDEO_ADS_CAMPAIGN_ID = {
    MOBILE: 'ai_generated_ads_video_pwa_mobile_v2',
    DESKTOP: 'ai_generated_ads_video_pwa_desktop_v2'
};

export const AI_VIDEO_ADS_GENERAL_CONFIG_NAME = 'ai_generated_video';

export const AI_VIDEO_ADS_FEAT_STATUS = {
    CONCLUDED: 'concluded',
    IN_TESTING: 'in_testing'
};

export const AI_VIDEO_ADS_STORAGE = 'ai_generated_video_variant';
